import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["btn", "tab"];
  static values = {
    defaultTab: String
  }

  connect() {
    this.tabTargets.map(x => x.hidden = true);
    this.btnTargets.map(x => x.classList.remove("active"));
    const buttonActive = this.btnTargets.find(x => x.getAttribute("tab-id") === this.defaultTabValue)
    buttonActive.classList.add("active");

    const selectedTab = this.tabTargets.find(element => element.getAttribute("tab-id") === this.defaultTabValue);
    selectedTab.hidden = false;
  }

  select(event) {
    const selectedTab = this.tabTargets.find(element => element.getAttribute("tab-id") === event.currentTarget.getAttribute("tab-id"))
    if (selectedTab.hidden) {
      this.tabTargets.map(x => x.hidden = true);
      this.btnTargets.map(x => x.classList.remove("active"));

      selectedTab.hidden = false;
      // event.target.classList.add("active");
      const buttonActive = this.btnTargets.find(x => x.getAttribute("tab-id") === event.currentTarget.getAttribute("tab-id"));
      buttonActive.classList.add("active");
    }
  }
}
